import ff from './ff';

export default class i14d {

static d_defs = {

/*
  DROP TABLE t_i14r;
  CREATE TABLE t_i14r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    i14rb21f INTEGER,
    i14ri11i INTEGER,
    i14ri12i INTEGER,
    i14ri21i INTEGER,
    i14ri31i INTEGER,
    i14ri42i INTEGER,
    i14ri52i INTEGER,
    i14ri61i INTEGER,
    i14ri62i INTEGER,
    i14ri71s TEXT,
    i14ri72s TEXT,
    i14ri73s TEXT,
    i14ri81s TEXT,
    i14ri82s TEXT,
    i14ri83s TEXT,
    i14ri91s TEXT,
    i14ri92s TEXT,
    i14ria1s TEXT,
    i14ria2s TEXT,
    i14rib1s TEXT,
    i14rib2s TEXT,
    i14rcx1i INTEGER,
    i14rcy1t TEXT,
    i14rcy1f INTEGER,
    i14rcz1i INTEGER
  );
  INSERT INTO t_i14r (_vsn, _ltt, i14rb21f, i14ri11i, i14ri21i, i14ri31i, i14ri12i, i14ri42i, i14ri52i, i14ri61i, i14ri62i, i14ri71s, i14ri72s, i14ri73s, i14ri81s, i14ri82s, i14ri91s, i14ri92s, i14ria1s, i14ria2s, i14rib1s, i14rib2s, i14rcx1i, i14rcy1t, i14rcy1f, i14rcz1i) 
  VALUES (1, 1, 1, 1, 2, 7, 2, 1, 4, 5, 5, 'エントリー抽選後の空き室・設備を先着順で予約', '翌々月に使用する室・設備の予約抽選', 'メールアドレス・パスワード変更', '予約対象：翌々月までの空き枠
（翌々月についてのWEB直接予約は22日21:00から）
時期により予約できる件数に制限があります。詳しくは利用ガイドをご確認ください。', '受付：毎月1日〜10日
抽選結果発表：その月の17日 12:00
エントリーは地区センター枚に1団体2件までです', '次のとおり、利用を申請します。', 'black', '障害施設を利用される方々の為に、駐車場の利用はできるだけご遠慮ください。
やむを得ない場合は、会場利用申込み時に、駐車希望をご申請ください。 ※1団体1台のみ', 'red', '・使用料は3時間を1件として計算します。
・使用時間が3時間に満たない場合も全額支払いが必要です。', 'black', 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i14r SET _fst = _key;
*/

  i14r: {
    0: {
      pfx: '利用会社設定情報',
      dd_fldDefss: {
        i14rb21f: {
          pfx: 'c20r_fst',
          type: 'Inp',
        },

        i14ri11i: { // i11i
          pfx: '予約可能月数',
          type: 'Inp',
          n_col: 4,
        },
        i14ri12i: { // i12i
          pfx: 'エントリー可能月数',
          type: 'Inp',
          n_col: 4,
        },

        i14ri21i: { // i21i,
          pfx: '予約可能日数',
          type: 'Inp',
          n_col: 4,
        },

        i14ri31i: { // i31i
          pfx: '予約キャンセル可能日数',
          type: 'Inp',
          n_col: 4,
        },

        i14ri42i: { // i42i
          pfx: 'エントリー開始日',
          type: 'Inp',
          n_col: 4,
        },

        i14ri52i: { // i52i
          pfx: 'エントリー終了日',
          type: 'Inp',
          n_col: 4,
        },

        i14ri61i: {
          pfx: '予約可能月間コマ数',
          type: 'Inp',
          n_col: 4,
        },
        i14ri62i: {
          pfx: 'エントリー可能月間コマ数',
          type: 'Inp',
          n_col: 4,
        },

        i14ri71s: {
          pfx: '直接予約説明文1',
          type: 'Inp',
          n_col: 40,
        },
        i14ri72s: {
          pfx: 'エントリー説明文1',
          type: 'Inp',
          n_col: 40,
        },
        i14ri73s: {
          pfx: '設定説明文1',
          type: 'Inp',
          n_col: 40,
        },


        i14ri81s: {
          pfx: '直接予約説明文2',
          type: 'Inp',
          n_col: 40,
        },
        i14ri82s: {
          pfx: 'エントリー説明文2',
          type: 'Inp',
          n_col: 40,
        },
        i14ri83s: { // 現時点では不使用
          pfx: '設定説明文2',
          type: 'Inp',
          n_col: 40,
        },

        i14ri91s: {
          pfx: '申請書説明文1',
          type: 'Inp',
          n_col: 40,
        },
        i14ri92s: {
          pfx: '申請書説明文1色',
          type: 'Pck',
          n_col: 5,
          ld_iss: [
            { key: 'black', pfx: '黒'},
            { key: 'red', pfx: '赤'}
          ]
        },
        i14ria1s: {
          pfx: '申請書説明文2',
          type: 'Inp',
          n_col: 40,
        },
        i14ria2s: {
          pfx: '申請書説明文2色',
          type: 'Pck',
          n_col: 5,
          ld_iss: [
            { key: 'black', pfx: '黒'},
            { key: 'red', pfx: '赤'}
          ]
        },
        i14rib1s: {
          pfx: '申請書説明文3',
          type: 'Inp',
          n_col: 40,
        },
        i14rib2s: {
          pfx: '申請書説明文3色',
          type: 'Pck',
          n_col: 5,
          ld_iss: [
            { key: 'black', pfx: '黒'},
            { key: 'red', pfx: '赤'}
          ]
        },

      },
    }
  },

};

};
